<template>
    <div
        class="field-colorpicker field-wrap"
        v-bind:class="{
            'field-colorpicker--has-focus': hasFocus,
            'field-colorpicker--has-content': simpleFieldGet.length
        }"
    >
        <label v-if="label" class="field-colorpicker__label">
            {{ label }}
            <span v-if="required" class="field-colorpicker__label-required">&nbsp;*</span>
        </label>

        <input
            class="field-colorpicker__input"
            @focus="openPicker"
            @blur="hasFocus = false"
            v-model="simpleFieldModel"
            type="text"
            :disabled="checkDisabled"
            :required="required"
        />

        <div class="field-colorpicker__frame" v-if="showPicker">
            <chrome-picker
                class="field-colorpicker__frame-pick"
                v-if="showPicker"
                :value="getColor"
                @input="setColor"
                @mouseleave="showPicker = false"
                :disabled="checkDisabled"
                :required="required"
            />
            <a
                v-tooltip="'Änderung speichern'"
                class="field-colorpicker__frame-close"
                v-if="showPicker"
                v-on:click.prevent="closePicker"
                href="#"
                >save</a
            >
            <a
                v-tooltip="'Änderung verwerfen'"
                class="field-colorpicker__frame-abort"
                v-if="showPicker"
                v-on:click.prevent="abortPicker"
                href="#"
                >abort</a
            >
        </div>
    </div>
</template>

<script>
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';
import { Chrome } from 'vue-color';
import { EventBus } from '@/helpers/event-bus';
import pushid from 'pushid';

export default {
    data() {
        return {
            id: pushid(),
            prevValue: null,
            hasFocus: false,
            showPicker: false
        };
    },
    components: {
        'chrome-picker': Chrome
    },
    methods: {
        setColor(value) {
            this.simpleFieldSet(value.hex);
        },
        openPicker() {
            this.prevValue = this.simpleFieldGet;
            this.showPicker = true;
            this.hasFocus = true;
            EventBus.$emit('colorpicker-close', this.id);
        },
        closePicker() {
            this.showPicker = false;
        },
        abortPicker() {
            this.simpleFieldSet(this.prevValue);
            this.showPicker = false;
        }
    },
    computed: {
        getColor() {
            return this.simpleFieldGet;
        }
    },
    mixins: [SimpleFieldMixin],
    props: {},
    mounted() {
        EventBus.$on('colorpicker-close', (id) => {
            if (id != this.id) {
                this.showPicker = false;
                this.hasFocus = false;
            }
        });
    },
    beforeDestroy() {
        EventBus.$off('colorpicker-close');
    }
};
</script>
